import { Hand, Fish, Wand2, Layers } from "lucide-react";

const ACTIONS = [
  { key: "pet", label: "Pet", sub: "slow warmth", icon: Hand, ring: "hover:border-sky-400/60 hover:shadow-[0_0_24px_-6px_rgba(56,189,248,0.7)]", color: "text-sky-300" },
  { key: "feed", label: "Feed", sub: "treat drop", icon: Fish, ring: "hover:border-amber-400/60 hover:shadow-[0_0_24px_-6px_rgba(245,158,11,0.7)]", color: "text-amber-300" },
  { key: "toy", label: "Dangle Toy", sub: "feather wand", icon: Wand2, ring: "hover:border-purple-400/60 hover:shadow-[0_0_24px_-6px_rgba(168,85,247,0.7)]", color: "text-purple-300" },
  { key: "rug", label: "Rug Trap", sub: "hide & pounce", icon: Layers, ring: "hover:border-pink-400/60 hover:shadow-[0_0_24px_-6px_rgba(236,72,153,0.7)]", color: "text-pink-300" },
];

export default function ActionDeck({ onAction, disabled }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4" data-testid="action-deck">
      {ACTIONS.map((a) => {
        const Icon = a.icon;
        return (
          <button
            key={a.key}
            data-testid={`${a.key}-button`}
            disabled={disabled}
            onClick={() => onAction(a.key)}
            style={{ transition: "transform 0.15s ease, border-color 0.2s ease, box-shadow 0.25s ease" }}
            className={`glass group flex flex-col items-start gap-2 rounded-2xl p-4 text-left border-white/10 ${a.ring} hover:scale-[1.04] active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed`}
          >
            <Icon className={`h-6 w-6 ${a.color}`} />
            <div>
              <p className="font-display font-bold text-slate-100 group-hover:text-white">{a.label}</p>
              <p className="font-mono-ui text-[10px] uppercase tracking-widest text-slate-500">{a.sub}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
